export const refreshPage = () => {
  try {
    window.location.reload();
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (e) {
    const currentLocation = window.location.href;
    window.location.href = currentLocation;
  }
};
